import { render, staticRenderFns } from "./AddressCreator.vue?vue&type=template&id=79842568"
import script from "./AddressCreator.vue?vue&type=script&lang=js"
export * from "./AddressCreator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports